import WarehouseProvider from './WarehouseDetailsContext';
import WarehouseDetails from './WarehouseDetails';
import { Page } from 'components';

let Index = () => {
    return (
        <WarehouseProvider>
            <Page title='Warehouse details' maxWidth='md'>
                <WarehouseDetails />
            </Page>
        </WarehouseProvider>
    )
}

export default Index;